// clock.ts — frame timing. Decoupled from the renderer so scenes can read
// elapsed/delta without touching requestAnimationFrame themselves.

export interface Frame {
  /** Seconds since the clock started. */
  readonly time: number;
  /** Seconds since the previous frame, clamped to avoid tab-switch spikes. */
  readonly delta: number;
  /** Monotonic frame counter. */
  readonly index: number;
}

export class Clock {
  private start = -1;
  private last = -1;
  private index = -1;

  /** Advance the clock with a high-res timestamp (from rAF). */
  tick(now: number): Frame {
    if (this.start < 0) {
      this.start = now;
      this.last = now;
    }
    const time = (now - this.start) / 1000;
    const delta = Math.min((now - this.last) / 1000, 1 / 15);
    this.last = now;
    this.index += 1;
    return { time, delta, index: this.index };
  }
}
